import React from 'react';
import clsx from 'clsx';
import { tokens } from './styles';
import { signedMoney, statusLabel } from './utils';

const DOTS = { CHANGED: tokens.teal, UNCHANGED: '#b9c4c7', NOT_FOUND: '#e0a030', FAILED: tokens.red };

/* Status counts that double as the table filter, plus the net GST and invoice amount movement. */
export const ResultSummary = ({ summary, dryRun, filter, onFilter, classes }) => {
    const { counts, gstDelta, amountDelta } = summary;
    const tiles = [
        { key: 'ALL', label: 'All invoices' },
        { key: 'CHANGED', label: statusLabel('CHANGED', dryRun) },
        { key: 'UNCHANGED', label: statusLabel('UNCHANGED', dryRun) },
        { key: 'NOT_FOUND', label: statusLabel('NOT_FOUND', dryRun) },
        { key: 'FAILED', label: statusLabel('FAILED', dryRun) },
    ];

    return (
        <div className={classes.tiles}>
            {tiles.map(({ key, label }) => (
                <button
                    key={key}
                    type="button"
                    aria-pressed={filter === key}
                    disabled={key !== 'ALL' && !counts[key]}
                    onClick={() => onFilter(filter === key ? 'ALL' : key)}
                    className={clsx(classes.tile, { [classes.tileActive]: filter === key })}>
                    <span className={classes.tileLabel}>
                        {DOTS[key] && <span className={classes.tileDot} style={{ backgroundColor: DOTS[key] }} />}
                        {label}
                    </span>
                    <span className={classes.tileValue}>{counts[key] || 0}</span>
                </button>
            ))}
            <div className={clsx(classes.tile, classes.tileStatic)}>
                <span className={classes.tileLabel}>Net GST change</span>
                <span className={classes.tileValue}>{signedMoney(gstDelta)}</span>
            </div>
            <div className={clsx(classes.tile, classes.tileStatic)}>
                <span className={classes.tileLabel}>Net invoice amount change</span>
                <span className={classes.tileValue}>{signedMoney(amountDelta)}</span>
            </div>
        </div>
    );
};
